import { useState } from "react";
import { Pencil } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";

export default function GradeEditor({ row, onSaved }) {
  const [edit, setEdit] = useState(false);
  const [v, setV] = useState(row.grade || "");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await api.patch(`/barcode/${row.barcode_id}/grade`, { grade: v, alasan: "Edit GRADE dari Data Stock" });
      toast.success(`GRADE ${row.barcode_id} → ${v.toUpperCase() || "(kosong)"}`);
      setEdit(false); onSaved && onSaved();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (!edit) return <span className="grade-edit"><span data-testid={`grade-value-${row.barcode_id}`}>{row.grade || ""}</span> <button className="btn-icon" title="Edit GRADE" onClick={() => { setV(row.grade || ""); setEdit(true); }} data-testid={`grade-edit-${row.barcode_id}`}><Pencil size={11} /></button></span>;
  return (
    <span className="grade-edit">
      <input className="grade-input" value={v} onChange={(e) => setV(e.target.value.toUpperCase())} onKeyDown={(e) => { if (e.key === "Enter") save(); if (e.key === "Escape") setEdit(false); }} placeholder="SS400" autoFocus data-testid={`grade-input-${row.barcode_id}`} />
      <button className="btn-mini" disabled={busy} onClick={save} data-testid={`grade-save-${row.barcode_id}`}>OK</button>
      <button className="btn-mini" onClick={() => setEdit(false)} data-testid={`grade-cancel-${row.barcode_id}`}>✕</button>
    </span>
  );
}
